import { styles } from './template.scss';
import { styles as commonStyles } from '../../../assets/common.scss';
import { styles as styleHelpersStyles } from '../../../assets/style-helpers.scss';
import { FontSizes, FontWeights } from '../../../types/common/types';

export const templateComputersAndVirtualMachines = document.createElement('template');

templateComputersAndVirtualMachines.innerHTML = `
  <style>${commonStyles}</style>
  <style>${styles}</style>
  <style>${styleHelpersStyles}</style>

  <header class="page__header">
    <gz-title fontWeight='${FontWeights.MEDIUM}' fontSize='${FontSizes.TITLE}'></gz-title>
  </header>

  <gz-grid-view>
    <div class="header__actions" slot="grid-header-actions-slot">
      <gz-button id="addExclusions" class="mr-2" data-add-exclusions disabled></gz-button>
      <gz-button type="quiet" color="secondary" id="restoreTask" class="mr-2" data-restore disabled></gz-button>
      <gz-tooltip id="retrieve-tooltip">
        <gz-button type="quiet" color="secondary" id="retrieve" class="mr-2" disabled></gz-button>
      </gz-tooltip>
      <gz-button type="quiet" color="secondary" id="download" class="mr-2" disabled></gz-button>
      <gz-button type="quiet" color="secondary" id="empty-quarantine" class="mr-2" disabled></gz-button>
      <gz-button type="outline" color="negative" id="delete-task" class="mr-2" disabled></gz-button>
    </div>
  </gz-grid-view>
`;
